import { useState } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import About from "../components/About";
import GroupRule from "../components/GroupRule";
import HowWeWork from "../components/HowWeWork";
import Gallery from "../components/Gallery";
import Leadership from "../components/Leadership";
import Merchandise from "../components/Merchandise";
import DashboardEmbed from "../components/DashboardEmbed";
import Footer from "../components/Footer";
import JoinModal from "../components/JoinModal";

export default function Landing() {
    const [joinOpen, setJoinOpen] = useState(false);
    return (
        <div className="film-grain min-h-screen bg-meraki-bg text-meraki-text">
            <Nav onJoinClick={() => setJoinOpen(true)} />
            <Hero onJoinClick={() => setJoinOpen(true)} />
            <About />
            <GroupRule />
            <HowWeWork />
            <Gallery />
            <Leadership />
            <Merchandise />
            <DashboardEmbed />
            <Footer />
            <JoinModal open={joinOpen} onOpenChange={setJoinOpen} />
        </div>
    );
}
